export const SCORE_UPDATE_EVENT = 'namat:score_update';

export interface ScoreUpdateDetail {
  score: number;
  maxScore: number;
}

/** Opens the «مقياس نمط» window from elsewhere, e.g. the avatar (#124). */
export const OPEN_NAMAT_SCALE_EVENT = 'namat:open_scale';

export function openNamatScale(): void {
  window.dispatchEvent(new Event(OPEN_NAMAT_SCALE_EVENT));
}

export function dispatchScoreUpdate(detail: ScoreUpdateDetail): void {
  window.dispatchEvent(new CustomEvent<ScoreUpdateDetail>(SCORE_UPDATE_EVENT, { detail }));
}


